export const BKC_2025_BEGINNER_LV1 = [
  '飞机-跳剑', '游泳-竹蜻蜓', '企鹅手中皿-正手中皿-止剑', '天中杀', '神枪手止剑',
  '世界一周', '月面-收', '大鸟-止剑', '飞行V-持球收', '中皿-大皿-棒球大皿-止剑'
];

export const BKC_2025_BEGINNER_LV2 = [
  '大皿-手臂大皿-止剑', '筋斗云-持球收', '天地二段', '小丑大皿-止剑', 
  '大皿-离转大皿-止剑', '企鹅手游泳-转正手持剑-地球'
];

export const BKC_2025_BEGINNER_LV1_2 = [...BKC_2025_BEGINNER_LV1, ...BKC_2025_BEGINNER_LV2];

export const BKC_2025_ADVANCED_LV1 = [
  '小丑止剑', 'Tap灯台-逆0.5收', '转机', '天中杀-转灯台-持剑收', '一回转飞机-2跳剑',
  '小鸟-反地球小鸟-止剑', '月面-1回月面-持球收', '神枪手游泳-2圈地球', 
  '飞机-跳剑1.5小丑止剑', '勺式大皿-天中杀快手'
];

export const BKC_2025_ADVANCED_LV2 = [
  '飞机-跳剑1.5-转抛剑0.5圈持球收', '中皿insta企鹅手止剑快手', 
  '二late离转1小丑幽灵正月-一回收', '神枪手天中杀快手', 
  '逆月-一回转Cushion Tap逆月-一回转Cushion Tap收', '一Tap灯台-一Tap小丑止剑'
];

export const BKC_2025_ADVANCED_LV1_2 = [...BKC_2025_ADVANCED_LV1, ...BKC_2025_ADVANCED_LV2];
